import ReactGA from 'react-ga';

const REACT_APP_PROD_CDN_URL = 'https://vox.telbee.net';
const REACT_APP_DEV_CDN_URL  = 'https://vox-stage.telbee.net';

class _Tracker {
    constructor() {
        // a.k.a is tracking enabled
        this.initialized = false;

        this.f = ReactGA;
    }

    initialize() {
        // Alias the underlying tracker
        // for direct access to methods
        // Conditionally init
        if (process.env.REACT_APP_TRACKING && window.location.origin === REACT_APP_PROD_CDN_URL) {
            ReactGA.initialize(process.env.REACT_APP_PROD_TRACKING_UID)
            this.initialized = true;
        } else if (process.env.REACT_APP_TRACKING && window.location.origin === REACT_APP_DEV_CDN_URL) {
            ReactGA.initialize(process.env.REACT_APP_DEV_TRACKING_UID)
            this.initialized = true;
        }
    }
}

const ga = new _Tracker();
export default ga;